export enum ProfileLayoutType {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}
